import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { NavigateFunction } from 'react-router-dom';

export const tasksPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [{ label: 'Inicio', onClick: () => navigate('/') }];

export const childrenTaskPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...tasksPageBreadcrumbs(navigate),
  { label: 'Tareas', onClick: () => navigate('/tasks') },
];
